import buttonStyles from "../components/Button/Button.module.scss";
import { GridUIConfig } from "@aleksundshantu/aunds-utils-react/primitives/grid";

export const gridUIConfig: GridUIConfig = {
  classNames: {
    loadMoreButtonBase: buttonStyles.btn,
    loadMoreButtonVariant: {
      "is-primary": buttonStyles["is-primary"],
      "is-secondary": buttonStyles["is-secondary"],
    },
  },
  // labelKeyMap: {
  //   load_more_label: "read_more_label",
  // },
  // iconKeyMap: {
  //   loadMore: "open",
  // },
};
